<template><div><h1 id="dokumente" tabindex="-1"><a class="header-anchor" href="#dokumente"><span>Dokumente</span></a></h1>
<p>Dokumente, angezeigte — Anzeige der Dokumente zur Person, Veranstaltung, Verdankung usw.</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Frame werden alle zu einer Person oder zu einem Auftrag erstellten <RouteLink to="/manual/administration/dokumentproduktion.html" title="2. Document Output">XML-Output-Dokumente</RouteLink> in einer Liste angezeigt. Über eine Funktion können die Dokumentendateien geöffnet und angeschaut werden.</p>
<p>Pfad: <code v-pre>Personen → Personen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Datum</dt>
<dd>Erstelldatum des Dokumentes.</dd>
<dt>Job-ID</dt>
<dd>Job, womit das Dokument erstellt worden ist.</dd>
<dt>Laufnummer</dt>
<dd>Laufnummer zum Job</dd>
<dt>Dokumentensatz</dt>
<dd><a class="link" href="ft.refdata.do-doksatz.html" title="Dokumententensatz">Dokumentensatz</a> womit das Dokument erstellt worden ist.</dd>
<dt>Dokument</dt>
<dd>Dokument-ID gem. <a class="link" href="ft.refdata.do-dokumente.html" title="Dokumente, Stammtabelle">Dokumente</a> .</dd>
<dt>Typ</dt>
<dd>Dokument-Typ gem. <a class="link" href="ft.refdata.do-dokumente.html" title="Dokumente, Stammtabelle">Dokumente</a> .</dd>
<dt>Status</dt>
<dd>Produktionsstatus gem. <a class="link" href="ft.refdata.do-outputverwaltung.html" title="Outputverwaltung">Outputverwaltung</a> .</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="dokument-anzeigen" tabindex="-1"><a class="header-anchor" href="#dokument-anzeigen"><span>Dokument anzeigen</span></a></h3>
<p>Öffnet die Datei und zeigt sie im entsprechenden Programm an.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/administration/dokumentproduktion.html" title="2. Document Output">Document Output</RouteLink></p>
</div></template>


